const DEBUG_MESSAGE_TYPE = "cts-copilot-debug";
const DEBUG_RESET_MESSAGE_TYPE = "cts-copilot-debug-reset";
const STATE_HEARTBEAT_MS = 2000;

const isDebugEnabled = (): boolean =>
    window.self !== window.top && window.location.hash.includes("debug=1");

export const postCopilotDebug = (step: string, detail: string): void => {
    if (!isDebugEnabled()) return;
    window.parent.postMessage({ type: DEBUG_MESSAGE_TYPE, step, detail }, "*");
};

export const installCopilotDebugBridge = (getAccount: () => string | null): (() => void) => {
    if (!isDebugEnabled()) return () => undefined;

    const heartbeat = window.setInterval(() => {
        postCopilotDebug(
            "state",
            JSON.stringify({
                isForbidden: localStorage.getItem("isForbidden"),
                account: getAccount(),
            }),
        );
    }, STATE_HEARTBEAT_MS);

    const onMessage = (event: MessageEvent) => {
        if (event.data?.type !== DEBUG_RESET_MESSAGE_TYPE) return;
        localStorage.clear();
        window.location.reload();
    };
    window.addEventListener("message", onMessage);

    return () => {
        window.clearInterval(heartbeat);
        window.removeEventListener("message", onMessage);
    };
};
